export const validate = (name) => {
  let data = { ...name };
  for (let key of Object.keys(name).filter((key) => !key.includes("Error"))) {
    if (!name[key]) {
      data[key + "Error"] = true;
      data["notValid"] = true;
    } else {
      data[key + "Error"] = false;
      data["notValid"] = false;
    }
  }
  return data;
};

export function isValidHttpUrl(s) {
  let url;
  try {
    url = new URL(s);
  } catch (e) {
    return false;
  }
  return /https?/.test(url.protocol);
}

export function ValidEmail(email) {
  const regex = /^[\w\d._-]+@[a-z]+\.[a-z]{2,3}(\.[a-z]{2,3})?$/i;
  return regex.test(email);
}
export function validZipCode(zipcode) {
  // const regex = /[^\w\s]/gi;
  const regex = /^[a-zA-Z0-9]+$/;
  return regex.test(zipcode);
}


export function validUrl(zipcode) {
  // const regex = /[^\w\s]/gi;
  const regex =/^(ftp|http|https):\/\/[^ "]+$/;
  return regex.test(zipcode);
}